<template>
  <div id="Tab11">
    <ValidationObserver
      ref="formValidator"
      v-slot="{
        dirty,
      }"
    >
      <SaveObserver :dirty="dirty">
        <div v-if="!isPs" class="row mt-3 mb-3">
          <div class="col-lg-6 col-12">
            <section-title
              icon="fas fa-id-card"
              content="Servicios Educativos"
              container-class="tag-badge-main-info mt-1 mb-1"
            />
          </div>
          <div class="col-lg-6 col-12 justify-content-end d-flex">
            <section-title
              icon="fas fa-chalkboard-teacher"
              :content="totalEducationalServicesOwed"
              container-class="tag-badge-main-info mt-1 mb-1 title-bg"
            />
          </div>
        </div>
        <validation-observer
          v-if="!isPs"
          ref="educationalCompensatory"
          novalidate
          onsubmit="return false;"
          tag="form"
        >
          <div v-if="!hasCompensatoryHours">
            <!-- planillas del pei anterior -->

            <div
              class="row"
              v-if="Boolean(previousEducationalServices?.length)"
            >
              <div class="col-12">
                <validation-provider>
                  <p>
                    ¿Desea continuar con los servicios Educativos durante el
                    año?
                  </p>
                  <custom-radio
                    v-model="model.previousEducationalCompensatoryQuestion"
                    :is-inline="true"
                    name="rbPreviousEducationalCompensatory"
                    :options="previousEducationalCompensatoryOptions"
                    class="row"
                    :is-disabled="isReadOnly"
                    :change-event="savePreviousServiceAnswer"
                    custom-error-msg="Favor especificar."
                  />
                </validation-provider>
              </div>

              <Error
                v-if="hasPreviousUnanswered"
                class="mt-3"
                variant="no-border"
                message="Debe especificar si desea continuar con servicios educativos compensatorios previos."
              />
              <Error
                v-if="isYesSelectedOnPreviousWithoutServices"
                class="mt-3"
                variant="no-border"
                message="Indicó que desea continuar con servicios, pero no agregó servicios previos."
              />
              <Error
                v-if="hasAtLeastOneDocumentedWhenYes"
                class="mt-3"
                variant="no-border"
                message="Es requerido aceptar una solicitud."
              />
              <Error
                v-if="hasAtLeastOneDocumentedWhenNo"
                class="mt-3"
                variant="no-border"
                message="Es requerido rechazar una solicitud."
              />
              <div class="row col-12">
                <div class="col-12 my-3">
                  <educational-services-row
                    v-for="(service, index) in previousEducationalServices"
                    :index="index"
                    :item="service"
                    :needs-comp-services="
                      model.previousEducationalCompensatoryQuestion
                    "
                    :is-disabled="isReadOnly"
                    class="my-2"
                    @remove="removeEducationalService"
                    @edit="triggerEditMode"
                    @refresh="loadEducationalCompensatoryServices"
                  />
                </div>
              </div>
            </div>

            <!-- planillas nuevas -->

            <div class="row">
              <div class="col-12">
                <validation-provider>
                  <p>
                    {{ questionLabel }}
                  </p>
                  <custom-radio
                    v-model="model.educationalCompensatory"
                    :is-inline="true"
                    name="rbEducationalCompensatory"
                    :options="educationalCompensatoryOptions"
                    class="row"
                    :is-disabled="isReadOnly"
                    :change-event="saveCurrentServiceAnswer"
                    custom-error-msg="Favor especificar."
                  />
                </validation-provider>
              </div>
              <Error
                v-if="hasCurrentUnanswered"
                class="mt-3"
                variant="no-border"
                message="Debe especificar si requiere servicios educativos compensatorios."
              />
              <Error
                v-if="isYesSelectedOnCurrentWithoutServices"
                class="mt-3"
                variant="no-border"
                message="Indicó que necesita servicios, pero no agregó servicios educativos."
              />
              <Error
                v-if="isNoSelectedOnCurrentWithServices"
                class="mt-3"
                variant="no-border"
                message="Indicó que no necesita servicios, pero agregó servicios educativos."
              />
              <div class="row col-12">
                <div class="col-12 my-3">
                  <educational-services-row
                    v-for="(service, index) in educationalServices"
                    :index="index"
                    :item="service"
                    :needs-comp-services="model.educationalCompensatory"
                    :is-disabled="isReadOnly"
                    is-from-current-pei
                    class="my-2"
                    @remove="removeEducationalService"
                    @edit="triggerEditMode"
                    @refresh="loadEducationalCompensatoryServices"
                  />
                </div>
                <div
                  v-if="
                    isPanelVisible ||
                      (model.educationalCompensatory == true &&
                        educationalServices.length == 0)
                  "
                  class="col-12 academic-year-card mb-6"
                >
                  <div class="card-educational p-3 mt-3">
                    <div class="row">
                      <div class="col">
                        <icon-view
                          icon="far fa-calendar color-orange p-10"
                          icon-size="1rem"
                          :title="academicYearLabel"
                          variant="icon-view-extended"
                          class="mb-2 icon-view-color-text"
                        />
                      </div>
                    </div>
                    <validation-observer ref="addServiceForm">
                      <div class="row mt-3">
                        <div class="col-lg-5 col-12">
                          <div class="section-label">
                            ¿Para que Año se Adeudan estos Servicios?
                          </div>
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <custom-drop-down
                              v-model="model.academicYear"
                              custom-error-msg="El campo es requerido."
                              :error="errors[0]"
                              fieldkey="id"
                              fieldname="description"
                              :options="filteredAcademicYears"
                              placeholder="Seleccione"
                              class="w-100"
                              :disabled="isReadOnly || isEditModeActive"
                              @input="getService"
                            />
                          </validation-provider>
                        </div>
                      </div>
                      <div
                        v-if="hasYearSelected && hasService"
                        class="row mt-3  m-0  educational-details-container"
                      >
                        <div class="educational-detail-block">
                          <div class="educational-detail-icon">
                            <icon-view
                              :has-border="false"
                              icon="fas fa-book-user color-orange p-10"
                              icon-size="1rem"
                              class="no-shadow"
                            />
                          </div>
                          <div class="educational-detail-label font-bold">
                            Servicio:
                          </div>
                          <div class="educational-detail-value">
                            {{ lastPeiEducationalService.service?.name }}
                          </div>
                        </div>
                        <div class="educational-detail-block">
                          <div class="educational-detail-icon">
                            <icon-view
                              :has-border="false"
                              icon="fas fa-clock color-orange p-10"
                              icon-size="1rem"
                              class="no-shadow"
                            />
                          </div>
                          <div class="educational-detail-label font-bold">
                            Duración:
                          </div>
                          <div class="educational-detail-value">
                            {{ lastPeiEducationalService?.duration?.name }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="hasYearSelected && hasService"
                        class="card-educational-info"
                      >
                        <div class="info-block w-100">
                          <div class="info-label">
                            Cantidad de Días que se interrumpió el Servicio
                            Educativo:
                          </div>
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required|min_value:1"
                          >
                            <custom-input
                              type="number"
                              v-model="model.days"
                              custom-error-msg="El campo es requerido y con un mínimo de 1."
                              :error="errors[0]"
                              maxlength="500"
                              :min="1"
                            />
                          </validation-provider>
                        </div>
                        <div class="info-block">
                          <div class="info-label">Horas Adeudadas:</div>
                          <div class="info-value info-warning">
                            {{ hoursOwed }} horas
                          </div>
                        </div>
                        <div class="info-block w-100">
                          <div class="info-label">Razón de Ausencia:</div>
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <custom-drop-down
                              v-model="model.reason"
                              custom-error-msg="El campo es requerido."
                              :error="errors[0]"
                              fieldkey="id"
                              fieldname="name"
                              :options="reasons"
                              placeholder="Seleccione"
                              class="w-100"
                              :disabled="isEditModeActive"
                            />
                          </validation-provider>
                        </div>
                      </div>
                      <div
                        v-if="hasYearSelected && hasService"
                        class="d-flex flex-row justify-content-end w-100 pb-4"
                      >
                        <ActionButton
                          id="btnCancel"
                          variant="outline-danger mr-2"
                          type="button"
                          i="fas fa-times-circle"
                          @click="cancel()"
                        >
                          Cancelar
                        </ActionButton>
                        <ActionButton
                          id="btnAdd"
                          type="button"
                          variant="success"
                          @click="add()"
                          i="fas fa-file-plus"
                        >
                          {{ isEditModeActive ? 'Guardar' : 'Añadir' }}
                        </ActionButton>
                      </div>
                    </validation-observer>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  educationalServices.length >= 1 &&
                    !isPanelVisible &&
                    filteredAcademicYears.length >= 1
                "
                class="row col-12"
              >
                <div
                  class="col-12 d-flex justify-content-end align-items-center"
                >
                  <ActionButton
                    id="btnAdd"
                    type="button"
                    variant="success"
                    @click="isPanelVisible = true"
                    i="fas fa-file-plus"
                    :disabled="isReadOnly"
                  >
                    Añadir Servicio
                  </ActionButton>
                </div>
              </div>
            </div>
          </div>
          <Error
            v-else
            class="mt-3 pl-3"
            is-alert-mode
            message="El estudiante no cuenta con planillas de compensación de servicio."
          />
        </validation-observer>

        <div class="row">
          <service-compensation-tab
            :sie="selectedStudent.studentId"
            :pei-id="pei"
            :is-pei-complete="isComplete"
            :can-show-validation="false"
            :read-only="isReadOnly"
            :has-error="false"
            :active-educational-compensatory-service="true"
            class="col-12"
          />
        </div>
      </SaveObserver>
    </ValidationObserver>
  </div>
</template>

<script>
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import { SectionTitle } from '@/components/pei/shared';
import { StrongTitle } from '@/components/pei/tabs/components/tab6';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import SaveObserver from '@/components/common/SaveObserver';
import Error from '@/components/common/Error';
import store from '@/store/index';
import CustomInput from '@/components/common/CustomInput';
import IconView from 'icon-view';
import CustomRadio from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import generalService from '@/services/pei/general';
import ActionButton from '@/components/common/ActionButton';
import ServiceCompensationTab from '../programservice/tabs/ServiceCompensationTabRow.vue';
import peiStatusEnum from '@/utils/constants/pei/peiStatus.js';
import EducationalServicesRow from './components/tab11/EducationalServicesRow.vue';
import compensatoryRequestTypes from '@/utils/constants/compensatoryRequestTypes';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus.js';

export default {
  name: 'Tab11',
  mixins: [mixWait, mixAlert],
  components: {
    StrongTitle,
    SectionTitle,
    ValidationProvider,
    ValidationObserver,
    SaveObserver,
    Error,
    CustomInput,
    IconView,
    CustomRadio,
    CustomDropDown,
    ActionButton,
    ServiceCompensationTab,
    EducationalServicesRow,
  },
  data() {
    return {
      balance: 0,
      peiStatus: store.getters.SelectedPeiStatus,
      pei: store.getters.SelectedPei,
      model: {
        educationalCompensatory: null,
        previousEducationalCompensatoryQuestion: null,
        academicYear: null,
        days: null,
      },
      lastPeiEducationalService: {
        service: null,
        duration: null,
      },
      academicYears: [],
      reasons: [],
      educationalCompensatoryOptions: [
        {
          id: 1,
          name: 'Si',
          value: true,
          label: 'Si',
          check: false,
          invalid: false,
        },
        {
          id: 2,
          name: 'No',
          value: false,
          label: 'No ',
          check: false,
          invalid: false,
        },
      ],
      previousEducationalCompensatoryOptions: [
        {
          id: 3,
          name: 'Si',
          value: true,
          label: 'Si',
          check: false,
          invalid: false,
        },
        {
          id: 4,
          name: 'No',
          value: false,
          label: 'No ',
          check: false,
          invalid: false,
        },
      ],
      educationalServices: [],
      previousEducationalServices: [],
      isPanelVisible: false,
      isEditModeActive: false,
      currentRequestId: null,
    };
  },
  computed: {
    isPs() {
      return this.$store.state.pei.configUnilateralFlag == '1';
    },
    validator() {
      return store.getters.tab11Validator;
    },
    questionLabel() {
      return Boolean(this.previousEducationalServices?.length === 0)
        ? '¿Debe servicios compensatorios educativos?'
        : '¿Desea agregar servicios compensatorios educativos adicionales?';
    },
    hasCompensatoryHours() {
      return (
        this.previousEducationalServices?.length == 0 &&
        this.educationalServices?.length == 0 &&
        store.getters.SelectedPeiStatus == Number(peiStatusEnum.Firmado)
      );
    },
    hasCurrentUnanswered() {
      return this.validator.hasEducationalCompensationCurrentServiceUnanswered();
    },
    hasPreviousUnanswered() {
      return this.validator.hasEducationalCompensationPreviousServiceUnanswered();
    },
    isYesSelectedOnCurrentWithoutServices() {
      return this.validator.isYesSelectedOnCurrentWithoutServices();
    },
    isYesSelectedOnPreviousWithoutServices() {
      return this.validator.isYesSelectedOnPreviousWithoutServices();
    },
    isNoSelectedOnCurrentWithServices() {
      return this.validator.isNoSelectedOnCurrentWithServices();
    },
    hasAtLeastOneDocumentedWhenYes() {
      return this.validator.hasAtLeastOneDocumentedWhenYes();
    },
    hasAtLeastOneDocumentedWhenNo() {
      return this.validator.hasAtLeastOneDocumentedWhenNo();
    },
    filteredAcademicYears() {
      const usedIdsCurrent = this.educationalServices.map(
        (es) => es.academicYear?.id
      );
      const usedIdsPrevious = this.previousEducationalServices.map(
        (es) => es.academicYear?.id
      );
      const allUsedIds = [...new Set([...usedIdsCurrent, ...usedIdsPrevious])];

      return this.academicYears.filter((y) => !allUsedIds.includes(y.id));
    },
    isReadOnly() {
      return store.getters.SelectedPeiStatus != Number(peiStatusEnum.Borrador);
    },
    isComplete() {
      return (
        store.getters.SelectedPeiStatus == Number(peiStatusEnum.Completado)
      );
    },
    academicYearLabel() {
      return 'Año Académico: ' + store.getters.getPeiInfo.academicYear;
    },
    selectedStudent() {
      return store.getters.SelectedStudent;
    },
    totalEducationalServicesOwed() {
      return `Total de Servicios Educativos Adeudados: ${this.balance.toFixed(
        2
      )}`;
    },
    hoursOwed() {
      return (this.hasService
        ? (this.lastPeiEducationalService?.duration?.value / 60) *
          this.model.days
        : 0
      ).toFixed(2);
    },
    hasYearSelected() {
      return this.model.academicYear !== null;
    },
    hasService() {
      return (
        this.lastPeiEducationalService !== '' &&
        this.lastPeiEducationalService !== null &&
        this.lastPeiEducationalService?.service?.name !== null
      );
    },
  },
  async activated() {
    this.getOptions();
    this.getEducationalCompensatoryServiceBalance();
    store.commit('setSaveMethod', this.save);
    store.commit('setSaveBtnVisibility', true);
  },
  methods: {
    handleSubmit() {
      store.dispatch('saveChangesOnForm');
    },
    async validate() {
      this.proyectedDateEmptyErrorMsg = '';
      const formValid = await this.$refs.formValidator.validate();
      return formValid;
    },
    cancel() {
      this.model.academicYear = null;
      this.model.days = null;
      this.model.reason = null;
      this.isPanelVisible = false;
      this.isEditModeActive = false;
      this.$refs.educationalCompensatory.reset();
      this.$refs.addServiceForm.reset();
    },
    async removeEducationalService(index, request) {
      if (Boolean(request?.id)) {
        try {
          await generalService.removeEducationalService(request?.id);
          await this.loadEducationalCompensatoryServices();

          this.ShowToast(
            'Completado',
            'Servicio ha sido eliminado exitosamente.',
            'success'
          );
        } catch (e) {
          this.ShowToast('', e.message || 'error', 'error');
        }
      } else {
        this.educationalServices.splice(index, 1);
      }
    },
    async triggerEditMode(item) {
      this.isPanelVisible = true;
      this.isEditModeActive = true;
      this.currentRequestId = item.id;

      this.model.academicYear = item.academicYear;
      await this.getService();
      this.model.days = item.interventionAmount;
      this.model.reason = this.reasons.find(
        (reason) => reason.id == item.reasonId
      );
    },
    async save(changeQuestionOnly = false) {
      // En PEI unilateral (isPs) la sección de Servicios Educativos no se renderiza, así que no existe el ref ni hay nada que guardar aquí.
      // Aun así se confirma el guardado al usuario.
      if (!this.$refs.educationalCompensatory) {
        this.ShowToast(
          'Completado',
          'Su información ha sido guardada.',
          'success'
        );
        return;
      }

      const isValid = await this.$refs.educationalCompensatory.validate();

      if (!isValid) return;

      const payload = {
        changeQuestionOnly: changeQuestionOnly,
        peiId: this.pei,
        hasCurrentCompensatoryNeed: this.model.educationalCompensatory,
        hasPreviousCompensatoryNeed: this.model
          .previousEducationalCompensatoryQuestion,
        educationalServices: this.educationalServices
          .filter((x) => !x.requestNumber)
          .map((es) => ({
            requestNumber: es.requestNumber,
            academicYearId: es.academicYear?.id,
            disciplineTypeId: es.disciplineType?.id,
            durationId: es.durationId,
            studentSieId: es.studentSieId,
            peiId: es.peiId,
            typeId: es.typeId,
            statusId: es.status?.id,
            interventionAmount: es.interventionAmount,
            reasonId: es.reason?.id,
            interventionHour: es.interventionHour,
            selectedToCompensate: es.selectedToCompensate,
          })),
        interventionToCompensate: [
          ...this.educationalServices,
          ...this.previousEducationalServices,
        ]
          .filter((x) => Boolean(x.requestNumber))
          .reduce((acc, current) => {
            const exists = acc.some(
              (item) => item.requestNumber === current.requestNumber
            );
            if (!exists) {
              acc.push({
                id: current?.id,
                selectedToCompensate: current.selectedToCompensate,
              });
            }
            return acc;
          }, []),
      };

      try {
        await generalService.saveEducationalCompensatoryServices(payload);
      } catch (e) {
        this.ShowToast('', e.message || 'error', 'error');
        // Se relanza para que saveChangesOnForm no limpie el FormDirty.
        throw e;
      }
      this.ShowToast(
        'Completado',
        'Su información ha sido guardada.',
        'success'
      );

      await this.loadEducationalCompensatoryServices();
      await this.$refs.educationalCompensatory.reset();
    },
    async updateService(payload) {
      payload.id = this.currentRequestId;
      await generalService.updateEducationalService(payload);
    },
    async add() {
      const isValid = await this.$refs.addServiceForm.validate();

      if (!isValid) return;

      const educationalServices = {
        // Estos vienen del modelo del formulario
        academicYear: this.model.academicYear,
        reason: this.model.reason,
        interventionAmount: parseInt(this.model.days),

        // Calculado
        interventionHour: parseFloat(this.hoursOwed),

        // Estos vienen del servicio cargado al seleccionar el año
        durationId: this.lastPeiEducationalService.duration?.id,
        disciplineType: this.lastPeiEducationalService?.service,
        typeId: compensatoryRequestTypes.Reposicion,
        status: { id: compensatoryRequestStatus.New, name: 'Nuevo' },
        requestNumber: null, // Lo llenará el backend
        studentSieId: Number(this.selectedStudent.studentId),
        peiId: this.pei,
        isSubmitted: false,
        selectedToCompensate: false,

        // viene calculado del backend
        offeredHours: 0,
      };

      if (this.isEditModeActive) {
        try {
          await this.updateService(educationalServices);
          await this.loadEducationalCompensatoryServices();

          this.ShowToast(
            'Completado',
            'Servicio ha sido actualizado exitosamente.',
            'success'
          );
        } catch (e) {
          this.ShowToast('', e.message || 'error', 'error');
        }
      } else {
        this.educationalServices.push(educationalServices);
      }
      this.isPanelVisible = false;
      this.cancel();
    },
    async saveCurrentServiceAnswer({ value }) {
      this.model.educationalCompensatory = value;
      await this.save(true);
    },
    async savePreviousServiceAnswer({ value }) {
      this.model.previousEducationalCompensatoryQuestion = value;
      await this.save(true);
    },
    async getOptions() {
      var { data } = await generalService.getEducationalCompensatoryOptions(
        store.getters.getPeiInfo.academicYearId
      );

      this.academicYears = data.academicYears;
      this.reasons = data.reasons;
    },
    async getEducationalCompensatoryServiceBalance() {
      var {
        data,
      } = await generalService.getEducationalCompensatoryServiceBalance(
        this.selectedStudent.studentId
      );

      this.balance = data;
    },
    async getService() {
      this.lastPeiEducationalService = null;
      this.model.days = null;
      this.model.reason = null;

      if (!this.model.academicYear) {
        return;
      }

      var { data } = await generalService.getLastPeiEducationalService(
        this.selectedStudent.studentId,
        this.model.academicYear.id
      );

      this.lastPeiEducationalService = data;
    },
    async loadEducationalCompensatoryServices() {
      const { data } = await generalService.getEducationalCompensatoryServices(
        this.pei,
        {
          studentSieId: Number(this.selectedStudent.studentId),
        }
      );

      if (!data) return;

      this.model.previousEducationalCompensatoryQuestion = data.educationalServices?.find(
        (x) => x.peiId != this.pei
      )?.hasPreviousCompensatoryNeed;

      this.model.educationalCompensatory = data.hasCurrentCompensatoryNeed;

      this.educationalServices = data.educationalServices
        .filter((s) => data.hasCurrentCompensatoryNeed && s.peiId == this.pei)
        .map((service) => ({
          id: service.id,
          requestNumber: service.requestNumber,
          academicYear: service.academicYear,
          reasonId: service.reasonId,
          interventionAmount: service.interventionAmount,
          interventionHour: service.interventionHour,
          durationId: service.durationId,
          disciplineType: service.disciplineType,
          typeId: service.typeId,
          status: service.status,
          studentSieId: service.studentSieId,
          peiId: data.peiId,
          isSubmitted: service.isSubmitted,
          offeredHours: service.offeredHours ?? 0,
          selectedToCompensate: service.selectedToCompensate,
          rejectionDocumentAttachmentId: service.rejectionDocumentAttachmentId,
          fileName: service.fileName,
        }));

      this.previousEducationalServices = data.educationalServices
        .filter(
          (s) =>
            s.peiId != this.pei && s.status.id != compensatoryRequestStatus.New
        )
        .map((service) => ({
          id: service.id,
          requestNumber: service.requestNumber,
          academicYear: service.academicYear,
          reasonId: service.reasonId,
          interventionAmount: service.interventionAmount,
          interventionHour: service.interventionHour,
          durationId: service.durationId,
          disciplineType: service.disciplineType,
          typeId: service.typeId,
          status: service.status,
          studentSieId: service.studentSieId,
          peiId: data.peiId,
          isSubmitted: service.isSubmitted,
          offeredHours: service.offeredHours ?? 0,
          selectedToCompensate: service.selectedToCompensate,
          rejectionDocumentAttachmentId: service.rejectionDocumentAttachmentId,
          fileName: service.fileName,
        }));

      //Esconde panel si hay datos
      this.getEducationalCompensatoryServiceBalance();
    },
  },
  async mounted() {
    await this.loadEducationalCompensatoryServices();
  },
};
</script>

<style scoped>
::v-deep .tag-badge-main-info.title-bg {
  background: #f1f6f4 no-repeat padding-box !important;
  border: #e2e2e2 solid 1px;
  div.dot {
    background-color: #2db782 !important;
  }
}

::v-deep .tag-badge-main-info.title-bg div.dot {
  background-color: #2db782 !important;
}

::v-deep .no-shadow .dot {
  box-shadow: none !important;
}

.card-educational {
  width: 100%;
  background: #f1f6f4;
  border-radius: 6px;
  outline: 1px #e2e2e2 solid;
  outline-offset: -1px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.card-educational-header {
  padding: 24px;
  background: #f1f6f4;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-educational-section {
  padding: 0 24px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.section-label {
  color: #11291b;
  font-size: 14px;
  font-family: Lato;
  font-weight: 600;
  line-height: 16.8px;
  margin-bottom: 10px;
}
.card-educational-info {
  display: flex;
  gap: 24px;
  padding: 24px 0 24px 0px;
}
.info-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 180px;
}
.info-label {
  color: #11291b;
  font-size: 14px;
  font-family: Lato;
  font-weight: 600;
  line-height: 16.8px;
}
.info-value {
  padding: 10px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-family: Lato;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.info-disabled {
  background: white;
  outline: 1px #e2e2e2 solid;
  outline-offset: -1px;
  color: #11291b;
}
.info-warning {
  background: #ffedbb;
  outline: 1px #f3af54 solid;
  outline-offset: -1px;
  color: #11291b;
}
.card-educational-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  padding: 0 24px 24px 24px;
}

.services-row {
  background-color: #fff;
  border-radius: 6px;
  outline: 1px #e2e2e2 solid;
  outline-offset: -1px;
  padding: 20px 0;
}

/* CSS */
.educational-details-container {
  width: 100%;
  height: 100%;
  padding: 24px;
  background: white;
  border-radius: 4px;
  outline: 1px #e2e2e2 solid;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
}

.educational-detail-block {
  flex: 1 1 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}

.educational-detail-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #11291b;
  font-size: 16px;
  font-family: Lato, sans-serif;
  font-weight: 700;
  line-height: 21.6px;
  word-wrap: break-word;
}

.font-bold {
  font-weight: 700;
}

.educational-detail-value {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #11291b;
  font-size: 16px;
  font-family: Lato, sans-serif;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
}
</style>
